import { spacing, color } from '@upstox/upstox-ui';

export const title: CSSFunction = ({ theme }) => ({
  marginBottom: spacing(theme, ['medium']),
  '@media (min-width:768px)': {
    marginBottom: spacing(theme, ['large']),
  },
});

export const videoWrapper: CSSFunction = ({ theme }) => ({
  position: 'relative',
  width: '100%',
  minHeight: 185,
  borderRadius: spacing(theme, ['xsmall']),
  '@media (min-width:768px)': {
    minHeight: 295,
  },
  '@media (min-width:991px)': {
    minHeight: 495,
  },
});

export const ipoAnalysis: CSSFunction = ({ theme }) => ({
  marginBottom: spacing(theme, ['xlarge']),
  '@media (min-width:768px)': {
    marginBottom: spacing(theme, [40]),
  },
});

export const playButton: CSSFunction = ({ theme }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  margin: 'auto',
  width: 36,
  height: 36,
  backgroundColor: color(theme, 'palette.black'),
  borderRadius: '50%',
  filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
  cursor: 'pointer',
  '@media (min-width:991px)': {
    width: 97,
    height: 97,
  },
  ':before': {
    position: 'absolute',
    content: '" "',
    border: `${spacing(theme, ['medium'])} solid transparent`,
    borderLeft: `${spacing(theme, [10])} solid ${color(
      theme,
      'palette.white',
    )}`,
    top: 0,
    bottom: 0,
    left: 8,
    right: 0,
    margin: 'auto',
    width: 0,
    height: 0,
    zIndex: '1',
    '@media (min-width:991px)': {
      border: `${spacing(theme, ['medium'])} solid transparent`,
      borderLeft: `${spacing(theme, [28])} solid ${color(
        theme,
        'palette.white',
      )}`,
      left: 24,
    },
  },
});
